<mat-card>
  <mat-card-header>
    <mat-card-title>Game State Settings</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div data-testid="game-state-status">
      @switch (activeGame!.State) {
        @case (gameStateEnum.Active) {
          <p data-testid="game-state-active">{{ activeGame?.Name }} is active. Draws will proceed as normal.</p>
        }
        @case (gameStateEnum.Inactive) {
          <p data-testid="game-state-inactive">{{ activeGame?.Name }} is inactive. No more draws will take place.</p>
        }
        @case (gameStateEnum.Paused) {
          <div data-testid="game-state-paused">
            <p>{{ activeGame?.Name }} is paused.</p>
            <p>It will unpause automatically on {{ activeGame?.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
          </div>
        }
        @case (gameStateEnum.PauseAfterNextDraw) {
          <div data-testid="game-state-pause-after-next-draw">
            <p>{{ activeGame?.Name }} is currently active, but will be paused after the draw on {{ activeDraw?.EndedOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
            <p>It will unpause automatically on {{ activeGame?.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
          </div>
        }
        @case (gameStateEnum.PauseAfterNextWinner) {
          <div data-testid="game-state-pause-after-next-winner">
            <p>{{ activeGame?.Name }} is currently active, but will be paused the next time a player wins a draw.</p>
            <p>It will unpause automatically on {{ activeGame?.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
          </div>
        }
        @case (gameStateEnum.PauseAfterNextDrawCancelAutoplays) {
          <div data-testid="game-state-pause-after-next-draw-cancel-autoplays">
            <p>{{ activeGame?.Name }} is currently active, but will be paused after the draw on {{ activeDraw?.EndedOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
            <p>It will unpause automatically on {{ activeGame?.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
            <p>All autoplays will be cancelled when the game is paused.</p>
          </div>
        }
        @case (gameStateEnum.PauseAfterNextWinnerCancelAutoplays) {
          <div data-testid="game-state-pause-after-next-winner-cancel-autoplays">
            <p>{{ activeGame?.Name }} is currently active, but will be paused the next time a player wins a draw.</p>
            <p>It will unpause automatically on {{ activeGame?.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
            <p>All autoplays will be cancelled when the game is paused.</p>
          </div>
        }
        @case (gameStateEnum.EndAfterNextDraw) {
          <p data-testid="game-state-end-after-next-draw">{{ activeGame?.Name }} is active, but will end after the draw on {{ activeDraw?.EndedOn | date: 'yyyy-MM-dd h:mm a' }}.</p>
        }
        @case (gameStateEnum.EndAfterNextWinner) {
          <p data-testid="game-state-end-after-next-winner">{{ activeGame?.Name }} is active, but will end the next time a player wins a draw.</p>
        }
      }
    </div>
    @if (activeGame?.Type === gameTypeEnum.GoldRush)
    {
      <div class="flex-row justify-space-between align-center custom-border-bottom" *hasPermission="permissionTypes.ModifyGameSettings">
        <div class="flex-66">
          @if (uiState === uiStateEnum.ShowLoading)
          {
            <mat-spinner></mat-spinner>
          } @else {
            <mat-slide-toggle
              data-testid="force-winner-toggle"
              [checked]="activeDraw?.ForceWinner"
              (change)="updateGameShouldForceWinnerStatus()">
              Force Winner in the current draw (Draw date: {{activeDraw?.EndedOn | date: 'yyyy-MM-dd h:mm a'}})
            </mat-slide-toggle>
          }
        </div>
      </div>
    }
    <div class="margin-top-med">
      <div class="flex-row">
        @if (!isGamePausedOrPendingPause()) {
          <button mat-raised-button
                  data-testid="pause-game-button"
                  *hasPermission="permissionTypes.PauseGameInstance"
                  color="primary"
                  (click)="openPauseGame()"
                  matTooltip="Prevents new draws until the unpause date"
                  matTooltipShowDelay="500">Pause Game
            <mat-icon>pause_circle</mat-icon>
          </button>
        } @else {
          <button mat-raised-button
                  data-testid="change-unpause-date-button"
                  *hasPermission="permissionTypes.PauseGameInstance"
                  color="primary"
                  (click)="openChangeUnpauseDate()"
                  matTooltip="Change when the game will automatically unpause"
                  matTooltipShowDelay="500">Change Unpause Date
            <mat-icon>schedule</mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="margin-top-med">
      <div class="flex-row">
        <button mat-raised-button
                data-testid="stop-game-button"
                *hasPermission="permissionTypes.StopGame"
                color="primary"
                (click)="openStopGame()"
                matTooltip="Prevents new draws and cancels all active autoplays. Cannot be undone."
                matTooltipShowDelay="500">Stop Game
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
    <div class="margin-top-med">
      <div class="flex-row">
        <button mat-raised-button
                data-testid="end-game-button"
                *hasPermission="permissionTypes.EndGame"
                (click)="openEndGame()"
                matTooltip="End game immediately and refund all current tickets"
                matTooltipShowDelay="500"
                color="warn">End Game
          <mat-icon>warning</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
